document.addEventListener('DOMContentLoaded', (event) => {
  function initVideoAutoplayOnIntersect() {
    const videosToBindIntersection = document.querySelectorAll('video[data-autoplay-on-intersect]');

    videosToBindIntersection.forEach((video) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              /**
               * Pause all other videos and play the intersecting one.
               * This behaviour is default but can be disabled by setting
               * data-pause-videos="false" on the video element.
               */
              const pauseVideos = entry.target.dataset.pauseVideos !== 'false';
              if (pauseVideos) {
                document.querySelectorAll('video').forEach((vid) => vid.pause());
              }
              entry.target.play();
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: parseFloat(video.dataset.autoplayOnIntersect) },
      );

      observer.observe(video);
    });
  }

  initVideoAutoplayOnIntersect();

  window.addEventListener('blocks:updated', initVideoAutoplayOnIntersect);
});
